<template>
	<div>
		<b-form-row>
			<b-form-group label="Plan tarifario" class="col-lg-12 col-12">
				<b-form-select  v-model="ratePlanId" :options="ratePlanOpts" @change="getDetailRatePlanSelected" />
			</b-form-group>
			<b-alert show variant="danger" v-if="showAlertChangeRp" class="col-12 text-center font-weight-bold">Cambiar el plan tarifario causará discrepancia con las configuraciones actuales de la promoción</b-alert>
		</b-form-row><br>
		<b-card border-variant="light" header="Agregar">
			<b-card-body class="container p-0">
				<section v-if="$root.isEmpty(ratePlanId)">
					<b-alert show variant="danger" class="text-center"><b>Seleccione un plan tarifario para continuar</b></b-alert>
				</section>
				<section v-else>
					<b-form-row>
						<b-form-group label="Tipo de servicio" class="col-lg-4 col-6">
							<b-form-select reset-button size="sm" v-model="formModel.serviceTypeId" :options="serviceTypeOpts"></b-form-select>
						</b-form-group>
						<b-form-group label="Zona pickup" class="col-lg-4 col-6">
							<b-form-select reset-button size="sm" v-model="formModel.fromZoneId" :options="zonesOpts"></b-form-select>
						</b-form-group>
						<b-form-group label="Zona dropoff" class="col-lg-4 col-6">
							<b-form-select reset-button size="sm" v-model="formModel.toZoneId" :options="zonesOpts">
							</b-form-select>
						</b-form-group>
					</b-form-row>
					<b-form-row v-if="!$root.isEmpty(priceDetailValidated)" class="justify-content-center">
						<b-col class="col-lg-10 col-12">
							<b-table small striped hover bordered :items="[priceDetailValidated]" :fields="detailPriceColumns">
								<template v-slot:cell(oneway)="row">
									${{row.item.oneway}} {{row.item.currency}}
								</template>
								<template v-slot:cell(roundtrip)="row">
									${{row.item.roundtrip}} {{row.item.currency}}
								</template>
							</b-table>
						</b-col>
					</b-form-row>

					<b-form-row>
						<b-form-group class="col-2" label="Ticket">
							<b-form-select reset-button size="sm" v-model="formModel.ticket">
								<b-select-option value="">Todos</b-select-option>
								<b-select-option value="roundtrip">Roundtrip</b-select-option>
								<b-select-option value="oneway">Oneway</b-select-option>
							</b-form-select>
						</b-form-group>

						<b-form-group class="col-3" inline v-if="formModelPromo.rateModifierType=='fixed_rate'">
							<span>
								Monto fijo por ride <md-icon :icon="'info'" v-b-tooltip.hover title="Este monto se aplicará individualmente al ride dependiendo si se compró por RT o OW"></md-icon>
							</span>
							<b-input-group size="sm" prepend="$" :append="currency">
								<b-form-input v-model="formModel.modifierAmount"></b-form-input>
							</b-input-group>

						</b-form-group>
						<b-form-group class="col-3" label="Modificación de tarifa" v-else>
							<b-input-group size="sm" :append="rateModifierTypeText(formModelPromo.rateModifierType)">
								<b-input-group-prepend>
									<b-form-select size="sm" v-model="formModel.modifierSign" :options="[{ value: 1, text: '+' },{ value: -1, text: '-' }]"/>
								</b-input-group-prepend>
								<b-form-input type="text" size="sm" v-model="formModel.modifierAmount" required />
							</b-input-group>
						</b-form-group>


						<b-form-group class="col-4" label=".">
							<b-form-checkbox v-model="formModel.applyReturn" >
								Aplica en orden inverso (Zonas)
							</b-form-checkbox>
						</b-form-group>

						<b-form-group label="."  class="col-lg-2 col-12" v-if="canAddItem.flag">
							<b-button variant="outline-primary" @click="addItem()">Agregar</b-button>
						</b-form-group>
						<b-alert show variant="warning" v-else class="col-12 text-center font-weight-bold mt-3">
							{{canAddItem.msg}}
						</b-alert>
					</b-form-row>
				</section>
			</b-card-body>
		</b-card>

		<b-form-row v-if="ratePlanId>0">
			<b-col class="col-12">
				<b-table striped hover :items="items" :fields="columns" small class="table-condensed">
					<template v-slot:cell(ticket)="row">
						<span v-if="$root.isEmpty(row.item.ticket)">Todos</span>
						<span v-else>{{row.item.ticket}}</span>
					</template>
					<template v-slot:cell(acciones)="row">
						<b-button size="sm" @click="confirmDelete(row.index)" variant="outline-danger"> <md-icon icon="delete"></md-icon></b-button>
					</template>
					<template v-slot:cell(index)="row">
						{{row.index+1}}
					</template>
					<template v-slot:cell(modifierAmount)="row">
						<span v-if="formModelPromo.rateModifierType=='fixed_rate'">
							${{row.item.modifierAmount}}{{currency}}
						</span>
						<span v-else>
							{{modifierSignText(row.item.modifierSign)}} {{row.item.modifierAmount}} ({{rateModifierTypeText(formModelPromo.rateModifierType)}})
						</span>

					</template>
					<template v-slot:cell(currency)="">
						{{currency}}
					</template>
					<template v-slot:cell(applyReturn)="row">
						<span v-if="row.item.applyReturn">Si</span>
						<span v-else>No</span>
					</template>
					<template v-slot:cell(isAvailable)="row">
						<span class="text-success" v-if="ruleIsAvailable(row.item).flag" style="cursor:pointer" >
							<md-icon icon="verified_user"></md-icon>
						</span>
						<span class="text-danger" v-else style="cursor:pointer" >
							<md-icon icon="report" v-b-tooltip.hover :title="ruleIsAvailable(row.item).message"></md-icon>
						</span>
					</template>
				</b-table>
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
export default {
	name: "PromoSettingsComponent",
	props: {
		embbebedOn:{
			type: [String],
			required: true,
		},
		embbebedOnId:{
			type: [String, Number],
			required: true,
		},
		formModelPromo:{//Promo que se esta creando/editando
			type: [Object],
			required: true,
		},
	},
	components: { },
	data() {
		const initialForm= {
			serviceTypeId:0,
			fromZoneId:0,
			toZoneId:0,
			modifierSign:1,
			modifierAmount:0,
			applyReturn:false,
			ticket:""
		};

		let columns = [
			{ key: "index", label: "#" },
			{ key: "serviceTypeData.name", label: "Service type" },
			{ key: "fromZoneData.name", label: "Zona Pickup" },
			{ key: "toZoneData.name", label: "Zona dropoff" },
			{ key: "ticketData.name", label: "ticket" },
			{ key: "modifierAmount", label: "Precio" },
			{ key: "currency", label: "Moneda Plan Tarifario" },
			{ key: "applyReturn", label: "¿Aplica Retorno?" },
			{ key: "isAvailable", label:"¿Disponible?"},
			{ key: "acciones", label: "acciones" },
		];


		return {
			ratePlanId:null,
			ratePlanList:[],
			ratePlanSelectedModel:null,
			formModel:{...initialForm},
			detailPriceColumns:[
				{key:"oneway",label:"One way"},
				{key:"roundtrip",label:"Roundtrip"},
			],
			items: [],
			columns:[...columns],
			rp:{
				serviceTypes:[],
				zones:[]
			},
			priceDetail:{
				key:-1,
				oneway:10,
				roundtrip:0,
				currency:0
			}
		};
	},
	computed: {
		ratePlanOpts(){
			let opts =  this.ratePlanList.map((rp)=>{
				return {value:rp.id,text:rp.title}
			})

			//..........................
			//se verifica que el ratePlanId esté en las opciones disponibles, Sino está se agrega al select
			if(this.ratePlanId>0){
				let ratePlanFoundInOptions = opts.find((rpOption)=>{
					return rpOption.value == this.ratePlanId;
				});
				if(this.$root.isEmpty(ratePlanFoundInOptions) && !this.$root.isEmpty(this.ratePlanSelectedModel)){
					if(this.ratePlanSelectedModel.id == this.ratePlanId){
						opts.push({value:this.ratePlanId,text:this.ratePlanSelectedModel.title})
					}
				}
			}
			//..........................
			return opts;
		},
		zonesOpts(){
			let optDefault = [{value:0,text:"Todas las zonas"}];
			let opts       = this.rp.zones.map((item)=>{
				return {value:item.id,text:"["+item.id+"] "+item.name}
			})
			return [...optDefault,...opts];
		},
		serviceTypeOpts(){
			let optDefault = [{value:0,text:"Todos los servicios"}];
			let opts       = this.rp.serviceTypes.map((item)=>{
				return {value:item.id,text:item.name}
			})
			return [...optDefault,...opts];
		},
		showAlertChangeRp(){
			if(!this.$root.isEmpty(this.formModelPromo.id)){
				if(this.formModelPromo.ratePlanId != this.ratePlanId) return true;
			}
			return false;
		},
		currency(){
			if(this.$root.isEmpty(this.ratePlanSelectedModel)) return "";
			return this.ratePlanSelectedModel.currency
		},
		priceDetailValidated(){
			let key = [this.formModel.serviceTypeId,this.formModel.fromZoneId,this.formModel.toZoneId].join()
			if(this.priceDetail.key ==-1) return null;
			if(this.priceDetail.key === key){
				return this.priceDetail;
			}
			return null;
		},
		canAddItem(){
			try{
				if(this.formModelPromo.rateModifierType === "fixed_rate"){
					if(!(this.formModel.serviceTypeId>0) || !(this.formModel.fromZoneId>0) || !(this.formModel.toZoneId>0)){
						throw "Para usar tarifa fija es requerido seleccionar el servicio y zonas";
					}
				}
			}catch(err){
				return {flag:false,msg:err};
			}
			return {flag:true};
		}
	},
	methods: {
		getNewResource(){
			return {
				serviceTypeId:0,
				fromZoneId:0,
				toZoneId:0,
				applyReturn:null,
				ticket:null,
				serviceTypeData:{
					name:""
				},
				fromZoneData:{
					name:""
				},
				toZoneData:{
					name:""
				},
				ticketData:{
					name:""
				},
			}
		},
		setData(promotionModel){
			let settings   = [...promotionModel.settings];
			this.items     = [...settings]
			this.ratePlanId = promotionModel.ratePlanId
			this.getDetailRatePlanSelected()
		},
		getData(){
			return {
				ratePlanId:this.ratePlanId,
				settings:this.items
			}
		},
		confirmDelete(index) {
			this.$bvModal.msgBoxConfirm('¿Esta seguro que desea eliminar este rango de fecha?', {
				title: 'Confirmación eliminación',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'SI, Eliminar!',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false
			})
			.then(value => {
				if(value) this.items.splice(index, 1);
			})
			.catch(err => {
				console.log(err)
			})
		},
		addItem(){
			try{
				if(this.$root.isEmpty(this.ratePlanId)) throw new Error("Seleccione un plan tarifario");
				if(this.$root.isEmpty(this.formModel.modifierSign)) throw new Error("Seleccione +/- modificación tarifa")
				if(this.$root.isEmpty(this.formModel.modifierAmount) || !(this.formModel.modifierAmount>0) ) throw new Error("Seleccione precio modificación tarifa")
			}catch(err){
				this.$root.showAlert(err.message,{variant:'danger'})
				return;
			}
			let item = this.getNewResource();
			item = {...item,...this.formModel}
			item = this.setNamesOfIds(item);
			try{
				//--------VALIDATION BEFORE ADD---------/
				let getArrayForComparation= function(item,invertZones=false){
					if(invertZones){
						return [item.ticket,item.serviceTypeId,item.toZoneId,item.fromZoneId]
					}else{
						return [item.ticket,item.serviceTypeId,item.fromZoneId,item.toZoneId]
					}
				}
				this.items.forEach((_item)=>{
					let itemToPushArr = getArrayForComparation(item);
					let itemArr       = getArrayForComparation(_item);
					if(itemToPushArr.join() == itemArr.join()) throw "repeated";
					if(_item.applyReturn){//si el item actual del recorrido tiene la opcion de que aplica retorno
						let itemToPushArr = getArrayForComparation(item);
						let itemArr       = getArrayForComparation(_item,true);//invertimos las zonas para la comparacion
						if(itemToPushArr.join() == itemArr.join()) throw "repeated";
					}
					if(item.applyReturn){//si el item a agregar tiene la opcion de que aplica retorno
						let itemToPushArr = getArrayForComparation(item,true);//invertimos las zonas para la comparacion
						let itemArr       = getArrayForComparation(_item);
						if(itemToPushArr.join() == itemArr.join()) throw "repeated";
					}
				})
			}catch(err){
				this.$root.showAlert("Ya se encuentra seleccionado esa configuración en la promocion",{variant:'info'});
				return;
			}
			//--------------------------------/
			this.items.push(item);
		},
		getRatePlansForPromotions(){
			this.$root.api.get(`util/promotions/${this.embbebedOn}/${this.embbebedOnId}/rate-plans-for-promotions`)
				.then((res) => {
					this.ratePlanList = res.data;
					if(this.ratePlanList.length <=0){
						this.$root.showAlert(`Este proveedor no tiene planes tarifarios configurados, para agregar una nueva promoción agrega al menos un plan tarifario`, {variant:'warning'});
					}

				}).catch(this.$root.handleRequestError);
		},
		getDetailRatePlanSelected(){
			this.$root.api.get(`util/promotions/rate-plans/${this.ratePlanId}`)
				.then((res) => {
					this.ratePlanSelectedModel = res.data;
					this.rp.serviceTypes = this.ratePlanSelectedModel.serviceTypes;
					if(this.embbebedOn == "supplier"){
						this.rp.zones        = this.ratePlanSelectedModel.supplierZonedArea.zones;
					}else{
						this.rp.zones        = this.ratePlanSelectedModel.zonedArea.zones;
					}

				}).catch(this.$root.handleRequestError);
		},
		setNamesOfIds(resourceItem){
			let cpResourceItem = {...resourceItem};
			let fields = ["serviceTypeId","fromZoneId","toZoneId"];
			fields.forEach(field=>{
				let keyToSet    = null;
				let collection  = null
				switch(field){
					case "serviceTypeId":
						keyToSet         = "serviceTypeData"
						collection       = [...this.serviceTypeOpts]
						break;
					case "fromZoneId":
						keyToSet = "fromZoneData"
						collection       = [...this.zonesOpts]
						break;
					case "toZoneId":
						keyToSet = "toZoneData"
						collection       = [...this.zonesOpts]
						break;
				}
				let found = collection.find(_item=>{
						return _item.value ==  cpResourceItem[field]
				})
				cpResourceItem[keyToSet].name = found.text
			})

			cpResourceItem.ticketData.name = (this.$root.isEmpty(cpResourceItem.ticket))?"Todos": cpResourceItem.ticket ;
			return cpResourceItem
		},
		modifierSignText(value){
			if(value==1) return "+"
			if(value==-1) return "-"
			return value;
		},
		rateModifierTypeText(val){
			let text = val;
			switch(val){
				case "percent":
					text ="%";
					break;
				case "amount":
					text= "$"
					break;
			}
			return text
		},
		searchPrice(){
			if(!(this.formModel.serviceTypeId)>0) return;
			if(!(this.formModel.fromZoneId)>0)return;
			if(!(this.formModel.toZoneId>0))return;
			this.$root.api.get(`util/promotions/rate-plans/${this.ratePlanId}/get-price`,{params: {filters:this.formModel}})
				.then((res) => {
					this.priceDetail     = res.data;
					this.priceDetail.key = [this.formModel.serviceTypeId,this.formModel.fromZoneId,this.formModel.toZoneId].join();
				}).catch(this.$root.handleRequestError);
		},
		ruleIsAvailable(rule){
			let serviceTypeId = rule.serviceTypeId;
			let fromZoneId    = rule.fromZoneId;
			let toZoneId      = rule.toZoneId;
			let messages      = [];

			if(serviceTypeId>0){
				let foundServiceType = this.serviceTypeOpts.find((item)=>{
					return item.value == serviceTypeId;
				})
				if(this.$root.isEmpty(foundServiceType)){
					messages.push("Tipo de servicio no esta disponible en el plan tarifario");
				}
			}
			if(fromZoneId>0){
				let foundZone = this.zonesOpts.find((item)=>{
					return item.value == fromZoneId;
				})
				if(this.$root.isEmpty(foundZone)){
					messages.push("Zona pickup no está disponible en el plan tarifario");
				}
			}
			if(toZoneId>0){
				let foundZone = this.zonesOpts.find((item)=>{
					return item.value == toZoneId;
				})
				if(this.$root.isEmpty(foundZone)){
					messages.push("Zona dropoff no está disponible en el plan tarifario");
				}
			}
			let flag = this.$root.isEmpty(messages)
			return {flag:flag,message:messages.join()}

		}
	},
	mounted() {
		this.getRatePlansForPromotions();
	},
	watch: {
		"formModel.serviceTypeId":function(){
			this.searchPrice();
		},
		"formModel.fromZoneId":function(){
			this.searchPrice();
		},
		"formModel.toZoneId":function(){
			this.searchPrice();
		},
		"formModelPromo.rateModifierType":function(){
			this.formModel.modifierAmount= 0;
		}
	}
};
</script>

<style>
.stacked-options .multiselect__tag {
	float: left;
}
</style>
